// Las siguientes variables vienen del script puesto en editor deframento, especificado en lay.componenteNoticias
const URL_MAS_NOTICIAS_VAR =
  // eslint-disable-next-line no-undef
  typeof URL_MAS_NOTICIAS !== 'undefined' ? URL_MAS_NOTICIAS : '/salud/Not/Paginas/Inicio.aspx';
// eslint-disable-next-line no-undef
const TITULO_NOTICIAS_VAR = typeof TITULO_NOTICIAS !== 'undefined' ? TITULO_NOTICIAS : '';
const MOSTRAR_NOTICIAS_SECUNDARIAS_VAR =
  // eslint-disable-next-line no-undef
  typeof MOSTRAR_NOTICIAS_SECUNDARIAS !== 'undefined' ? MOSTRAR_NOTICIAS_SECUNDARIAS : true;

const Noticias = ({ newsData }) => {
  return (
    <section>
      {TITULO_NOTICIAS_VAR.length > 0 && <h4>{TITULO_NOTICIAS_VAR}</h4>}

      <div className="newsModule">
        <div className="newsModule__primary">
          {newsData.primaryNews.map((item) => {
            return (
              <article className="newArticle" key={item.ID}>
                {item.srcString !== null && (
                  <a href={`${item.FileRef}`} title={item.Title} className="newArticle__imgLink" target="_blank" rel="noreferrer">
                    <picture>
                      <source srcset={`${item.srcString}?RenditionID=110`} media="(max-width: 575px)" />
                      <img src={`${item.srcString}?RenditionID=100`} alt={item.altString} class="img-responsive" />
                    </picture>
                  </a>
                )}
                <div className="newArticle__main">
                  <div className="newArticle__detalle">
                    <a href={item.FileRef} title={item.Detalle}>{item.Detalle}</a>
                  </div>
                  <div className="newArticle__fecha">
                    <time datetime={item.fechaConGuiones}>{item.fechaConFormato}</time>
                  </div>
                  <h3 className="newArticle__title">{item.Title}</h3>
                  {item.DescripcionNoticia && (
                    <div className="newArticle__description">
                      <div dangerouslySetInnerHTML={{ __html: item.DescripcionNoticia }} />
                    </div>
                  )}
                  {item.Comments && (
                    <div className="newArticle__comments">
                      <div dangerouslySetInnerHTML={{ __html: item.Comments }} />
                    </div>
                  )}
                  <div className="newArticle__verMas">
                    <a href={item.FileRef} title="Ver más" className="btn btn-primary" target="_blank" rel="noreferrer">
                      Ver más
                    </a>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
        {MOSTRAR_NOTICIAS_SECUNDARIAS_VAR && (
          <div className="newsModule__secundary">
            {newsData.secundaryNews.map((item) => {
              return (
                <article className="newArticle" key={item.ID}>
                  <div className="newArticle__detalle">
                    <a href={item.FileRef} title={item.Detalle}>{item.Detalle}</a>
                  </div>
                  <div className="newArticle__fecha">
                    <time datetime={item.fechaConGuiones}>{item.fechaConFormato}</time>
                  </div>
                  <h3 className="newArticle__title">{item.Title}</h3>
                  {item.DescripcionNoticia && (
                    <div className="newArticle__description">
                      <div dangerouslySetInnerHTML={{ __html: item.DescripcionNoticia }} />
                    </div>
                  )}
                  {item.Comments && (
                    <div className="newArticle__comments">
                      <div dangerouslySetInnerHTML={{ __html: item.Comments }} />
                    </div>
                  )}
                  <div className="newArticle__verMas">
                    <a href={item.FileRef} title="Ver más" className="btn btn-primary" target="_blank" rel="noreferrer">
                      Ver más
                    </a>
                  </div>
                </article>
              );
            })}
          </div>
        )}
        <div className="text-center newsModule__verMas">
          <a title="Leer más noticias" href={URL_MAS_NOTICIAS_VAR} className="btn btn-primary" target="_blank" rel="noreferrer">
            Leer más noticias
          </a>
        </div>
      </div>
    </section>
  );
};
export default Noticias;
